import React, { useEffect, useState } from "react";
import "./Exam.css";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  WarningOutlined,
  WarningTwoTone,
} from "@ant-design/icons";
import { Col, Row } from "antd";

interface Question {
  id: number;
  text: string;
  options: { text: string; score: number }[];
}

/*Ecco come solitamente viene interpretato il punteggio totale:

Da 0 a 18: Indica un alto rischio di cadute. Le persone con punteggi in questo intervallo possono essere considerate ad alto rischio e possono richiedere interventi di prevenzione delle cadute, come terapia fisica, correzioni ambientali o supporti per la mobilità.

Da 19 a 23: Indica un rischio moderato di cadute. Le persone con punteggi in questo intervallo possono avere un rischio moderato di cadute e potrebbero beneficiare di valutazioni aggiuntive e interventi mirati per migliorare l'equilibrio e la sicurezza nella deambulazione.

Da 24 a 28: Indica un rischio basso di cadute. Le persone con punteggi in questo intervallo hanno un rischio relativamente basso di cadute e possono avere un buon equilibrio e una buona capacità di deambulazione.*/

const TinettiTest: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>([
    {
      id: 1,
      text: "Equilibrio da seduto:",
      options: [
        { text: "Si inclina o scivola dalla sedia (0)", score: 0 },
        { text: "È stabile e sicuro (1)", score: 1 },
      ],
    },
    {
      id: 2,
      text: "Alzata dalla sedia:",
      options: [
        { text: "È incapace senza aiuto (0)", score: 0 },
        { text: "Deve aiutarsi con le braccia (1)", score: 1 },
        { text: "Si alza senza aiutarsi con le braccia (2)", score: 2 },
      ],
    },
    {
      id: 3,
      text: "Tentativo di alzata:",
      options: [
        { text: "È incapace senza aiuto (0)", score: 0 },
        { text: "Capace ma richiede più di un tentativo (1)", score: 1 },
        { text: "Capace al primo tentativo (2)", score: 2 },
      ],
    },
    {
      id: 4,
      text: "Equilibrio stazione eretta:",
      options: [
        {
          text: "Instabile (vacilla, muove i piedi, oscilla il troco) (0)",
          score: 0,
        },
        {
          text: "Stabile grazie all'ausilio di un bastone o altri ausili (1)",
          score: 1,
        },
        { text: "Stabile senza ausiliper il cammino (2)", score: 2 },
      ],
    },
    {
      id: 5,
      text: "Equilibrio stazione eretta prolungata:",
      options: [
        {
          text: "Instabile (vacilla, muove i piedi, oscilla il troco) (0)",
          score: 0,
        },
        {
          text: "Stabile ma a Base larga (malleoli mediali dist. >10cm ) (1)",
          score: 1,
        },
        { text: "Stabile a base stretta senza supporti (2)", score: 2 },
      ],
    },
    {
      id: 6,
      text: "Romberg:",
      options: [
        { text: "Instabile (0)", score: 0 },
        { text: "Stabile (1)", score: 1 },
      ],
    },
    {
      id: 7,
      text: "Romberg sensibilizzato:",
      options: [
        { text: "Incomincia a cadere (0)", score: 0 },
        { text: "Oscilla ma si riprende da solo (1)", score: 1 },
        { text: "Stabile (2)", score: 2 },
      ],
    },
    {
      id: 8,
      text: "Girarsi a 360°:",
      options: [
        { text: "A passi discontinui (0)", score: 0 },
        { text: "A passi continui (1)", score: 1 },
        { text: "Instabile (si appoggia, oscilla) (2)", score: 2 },
        { text: "Stabile (3)", score: 3 },
      ],
    },
    {
      id: 9,
      text: "Seduta:",
      options: [
        {
          text: "Insicuro (sbaglia la distanza, cade sulla sedia) (0)",
          score: 0,
        },
        { text: "Usa le braccia o ha un movimento discontinuo (1)", score: 1 },
        { text: "Sicuro, movimenti continui (2)", score: 2 },
      ],
    },
    {
      id: 10,
      text: "Inizio della deambulazione:",
      options: [
        { text: "Una certa esitazione o più tentativi (0)", score: 0 },
        { text: "Nessuna Esitazione (1)", score: 1 },
      ],
    },
    {
      id: 11,
      text: "Lunghezza del passo | Piede Dx:",
      options: [
        { text: "Durante il passo il piede Dx non supera il Sx(0)", score: 0 },
        { text: "Piede Dx supera il Sx (1)", score: 1 },
      ],
    },
    {
      id: 12,
      text: "Altezza del passo | Piede Dx:",
      options: [
        {
          text: "Piede Dx NON si alza completamente dal pavimento (0)",
          score: 0,
        },
        { text: "Piede Dx si alza completamente dal pavimento (1)", score: 1 },
      ],
    },
    {
      id: 13,
      text: "Lunghezza del passo | Piede Sx:",
      options: [
        { text: "Durante il passo il piede Sx non supera il Dx (0)", score: 0 },
        { text: "Piede Sx supera il Dx (1)", score: 1 },
      ],
    },
    {
      id: 14,
      text: "Altezza del passo | Piede Sx:",
      options: [
        {
          text: "Piede Sx NON si alza completamente dal pavimento (0)",
          score: 0,
        },
        { text: "Piede Sx si alza completamente dal pavimento (1)", score: 1 },
      ],
    },
    {
      id: 15,
      text: "Simmetria del passo:",
      options: [
        { text: "Il passo Dx e Sx NON sembrano uguali (0)", score: 0 },
        { text: "Il passo Dx e Sx sembrano uguali (1)", score: 1 },
      ],
    },
    {
      id: 16,
      text: "Continuità del passo:",
      options: [
        { text: "Interrotto o discontinuo (0)", score: 0 },
        { text: "Continuo (1)", score: 1 },
      ],
    },
    {
      id: 17,
      text: "Traiettoria:",
      options: [
        { text: "Marcata deviazione (0)", score: 0 },
        { text: "Lieve o modesta deviazione o uso di ausili (1)", score: 1 },
        { text: "Assenza di deviazione o uso di ausili (2)", score: 2 },
      ],
    },
    {
      id: 18,
      text: "Tronco:",
      options: [
        { text: "Marcata osciullazione o uso di ausili (0)", score: 0 },
        {
          text: "Nessuna oscillazione ma flessione di gambe, ginocchia, schiena o allargamento delle braccia durante il cammino (1)",
          score: 1,
        },
        {
          text: "Nessuna oscillazione, flassione o uso di ausili (1)",
          score: 1,
        },
      ],
    },
    {
      id: 19,
      text: "Traiettoria:",
      options: [
        { text: "I talloni sono separati (0)", score: 0 },
        { text: "I talloni quasi si toccano durante il cammino (1)", score: 1 },
      ],
    },
  ]);

  const [answers, setAnswers] = useState<number[]>(
    new Array(questions.length).fill(-1)
  );

  const handleAnswerChange = (questionId: number, optionIndex: number) => {
    setAnswers((prevAnswers) => {
      const newAnswers = [...prevAnswers];
      newAnswers[questionId - 1] = optionIndex;
      return newAnswers;
    });
  };

  const calculateScore = (): number => {
    let score = 0;
    answers.forEach((optionIndex, questionIndex) => {
      if (optionIndex !== -1) {
        score += questions[questionIndex].options[optionIndex].score;
      }
    });
    return score;
  };

  const interpretScore = (score: number): JSX.Element | string => {
    if (score >= 0 && score <= 1) {
      return (
        <>
          {" "}
          <CloseCircleTwoTone rev={undefined} twoToneColor="red" /> Non
          Deambulante
        </>
      );
    } else if (score >= 2 && score <= 19) {
      return (
        <>
          {" "}
          <WarningTwoTone rev={undefined} twoToneColor="red" />{" "}
          <WarningTwoTone rev={undefined} twoToneColor="red" />{" "}
          <WarningTwoTone rev={undefined} twoToneColor="red" /> Alto rischio
          cadute
        </>
      );
    } else if (score >= 20 && score <= 27) {
      return (
        <>
          {" "}
          <WarningTwoTone rev={undefined} twoToneColor="Orange" />{" "}
          <WarningTwoTone rev={undefined} twoToneColor="Orange" /> Moderato
          rischio cadute
        </>
      );
    } else {
      return (
        <>
          {" "}
          <CheckCircleTwoTone rev={undefined} twoToneColor="lightgreen" />{" "}
          Nessun rischio caduta
        </>
      );
    }
  };
  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 640 && (
        <Row>
          <Col span={8}></Col>
          <Col span={8}>
            <div>
              <div className="theSpace">
                <p>{interpretScore(calculateScore())}</p>
              </div>
              {questions.map((question) => (
                <div key={question.id}>
                  <p style={{ fontWeight: "bold", fontSize: "larger" }}>
                    {question.text}
                  </p>
                  <ul
                    style={{
                      listStyleType: "none",
                    }}
                  >
                    {question.options.map((option, index) => (
                      <li key={option.text}>
                        <label>
                          <input
                            type="radio"
                            name={`question_${question.id}`}
                            value={option.text}
                            onChange={() =>
                              handleAnswerChange(question.id, index)
                            }
                            checked={answers[question.id - 1] === index}
                          />
                          {option.text}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              <div>
                <p>{interpretScore(calculateScore())}</p>
              </div>
            </div>
          </Col>
          <Col span={8}></Col>
        </Row>
      )}
      {width <= 640 && (
        <>
          <div>
            <div className="theSpace">
              <p>{interpretScore(calculateScore())}</p>
            </div>
            {questions.map((question) => (
              <div key={question.id}>
                <p style={{ fontWeight: "bold", fontSize: "larger" }}>
                  {question.text}
                </p>
                <ul
                  style={{
                    listStyleType: "none",
                  }}
                >
                  {question.options.map((option, index) => (
                    <li key={option.text}>
                      <label>
                        <input
                          type="radio"
                          name={`question_${question.id}`}
                          value={option.text}
                          onChange={() =>
                            handleAnswerChange(question.id, index)
                          }
                          checked={answers[question.id - 1] === index}
                        />
                        {option.text}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div>
              <p>{interpretScore(calculateScore())}</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TinettiTest;
